import { environment } from '@env/environment';

export enum Companies {
  T2F = Number(environment.enums.companies.t2f),
  GF = Number(environment.enums.companies.gf),
  TFT = Number(environment.enums.companies.tft),
  GETA = Number(environment.enums.companies.geta),
  FRESH = Number(environment.enums.companies.fresh),
}
